import { List, ListSubheader } from "@mui/material";

import { Notification } from "../entity";
import { NotificationItem } from "./NotificationItem";

type NotificationListSection = {
  notifications: Notification[];
  title: string;
};

export const NotificationListSection = ({
  notifications,
  title,
}: NotificationListSection) => {
  return (
    <List
      disablePadding
      subheader={
        <ListSubheader
          disableSticky
          sx={{ px: 2.5, py: 1, typography: "overline" }}
        >
          {title}
        </ListSubheader>
      }
    >
      {notifications.map((notification) => (
        <NotificationItem key={notification.id} notification={notification} />
      ))}
    </List>
  );
};
